// Мини-язык фильтров задач — зеркало Swift TaskQuery (Terka/Features/Tasks/TaskQuery.swift).
// Держать parse/matches текстуально симметричными со Swift-версией.

const KNOWN_SOURCES = ['bemulti', 'delolet', 'terka'];

export function parseQuery(s) {
  const q = {
    priorities: new Set(),
    sources: new Set(),
    today: false,
    overdue: false,
    done: false,
    repeating: false,
    text: '',
  };
  const words = [];
  for (const raw of (s || '').trim().split(/\s+/).filter(Boolean)) {
    const t = raw.toLowerCase();
    const m = t.match(/^[pп]([1-4])$/);
    if (m) { q.priorities.add(Number(m[1])); continue; }
    if (t === 'today' || t === 'сегодня') { q.today = true; continue; }
    if (t === 'overdue' || t === 'просрочено') { q.overdue = true; continue; }
    if (t === 'done' || t === 'готово' || t === 'выполнено') { q.done = true; continue; }
    if (t === 'repeat' || t === 'повтор') { q.repeating = true; continue; }
    if (t.startsWith('source:')) {
      const v = t.slice('source:'.length);
      if (KNOWN_SOURCES.includes(v)) { q.sources.add(v); continue; }
    }
    words.push(raw);
  }
  q.text = words.join(' ');
  return q;
}

export function isEmptyQuery(q) {
  return !q || (
    q.priorities.size === 0 && q.sources.size === 0 &&
    !q.today && !q.overdue && !q.done && !q.repeating && q.text === ''
  );
}

export function matchesQuery(q, t) {
  // done переключает выборку целиком: без токена — только активные
  if (q.done) {
    if (!t.isDone) return false;
  } else if (t.isDone) {
    return false;
  }
  if (q.priorities.size > 0 && !q.priorities.has(t.priority)) return false;
  if (q.sources.size > 0) {
    const src = t.source || 'terka'; // source:terka матчит nil
    if (!q.sources.has(src)) return false;
  }
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  if (q.today) {
    const tomorrow = new Date(startOfToday);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (!t.dueDate || new Date(t.dueDate) >= tomorrow) return false;
  }
  if (q.overdue) {
    if (!t.dueDate || new Date(t.dueDate) >= startOfToday) return false;
  }
  if (q.repeating && !t.recurrence) return false;
  if (q.text) {
    const needle = q.text.toLowerCase();
    const inTitle = (t.title || '').toLowerCase().includes(needle);
    const inNotes = (t.notes || '').toLowerCase().includes(needle);
    if (!inTitle && !inNotes) return false;
  }
  return true;
}
